function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0001 28.5716C9.05684 28.5716 3.42871 22.9434 3.42871 16.0001C3.42871 9.05684 9.05684 3.42871 16.0001 3.42871C22.9415 3.42871 28.5716 9.05684 28.5716 16.0001C28.5716 22.9434 22.9415 28.5716 16.0001 28.5716ZM16.0001 26.1716C21.6167 26.1716 26.1716 21.6172 26.1716 16.0001C26.1716 10.3831 21.6167 5.82871 16.0001 5.82871C10.3823 5.82871 5.82871 10.3823 5.82871 16.0001C5.82871 21.618 10.3823 26.1716 16.0001 26.1716ZM21.4474 17.6552C22.0753 17.8672 22.4125 18.5481 22.2005 19.176C21.9885 19.8039 21.3076 20.1411 20.6796 19.929L15.0448 18.0265C14.5571 17.8618 14.2287 17.4043 14.2287 16.8895V11.1379C14.2287 10.4752 14.766 9.9379 15.4287 9.9379C16.0915 9.9379 16.6287 10.4752 16.6287 11.1379V16.0282L21.4474 17.6552Z",
  fill: "white"
});

function SvgRecent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "assets/media/recent.37f6659d.svg";
export { ForwardRef as ReactComponent };